import { H1Phonecall } from '@e3dc-react/icons'
import { Card, Divider, Link } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ContactInfoEmployee } from '../../models/order-history.model'
import { Typography } from '@e3dc-react/shell/Elements/Typography'

interface ContactInfoCardProps {
  salesEmployee?: ContactInfoEmployee | null
  backOfficeEmployee?: ContactInfoEmployee | null
}

const useStyles = makeStyles()(theme => ({
  container: {
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.only('xs')]: {
      flexWrap: 'wrap',
    },
  },
  contactIconContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    width: '84px',
    height: '84px',
  },
  contactIcon: {
    width: '36px',
    height: '36px',
  },
  divider: {
    borderColor: theme.palette.grey[300],
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
  contactContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    [theme.breakpoints.only('xs')]: {
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
  },
}))

const BACK_OFFICE_EMAIL = 'vertrieb@e3dc.com'

/*
 * This component renders a card that handles contact info to support for sales and backoffice
 */
const ContactInfoCard: React.FC<ContactInfoCardProps> = ({ salesEmployee, backOfficeEmployee }) => {
  const { classes } = useStyles()
  const salesEmployeeFullName = `${salesEmployee?.firstName ?? ''} ${salesEmployee?.lastName ?? ''}`.trim()
  const backOfficeEmployeeFullName = `${backOfficeEmployee?.firstName ?? ''} ${backOfficeEmployee?.lastName ?? ''}`.trim()
  return (
    <Box>
      <Card className={classes.container}>
        <Box className={classes.contactIconContainer}>
          <H1Phonecall className={classes.contactIcon} color="primary" />
          <Typography variant="subtitle1" color="primary">
            {'shop.order-history.contact-label'}
          </Typography>
        </Box>
        <Box className={classes.contactContainer}>
          {salesEmployee && (
            <Box>
              <Typography variant="subtitle2">{'shop.order-history.contact-sales-employee'}</Typography>
              <Typography variant="subtitle1">{salesEmployeeFullName}</Typography>
              <Typography variant="subtitle1">{salesEmployee.phone}</Typography>
              <Link href={`mailto:${salesEmployee.mail}`} underline="none">
                {salesEmployee.mail}
              </Link>
            </Box>
          )}
          <Divider className={classes.divider} orientation="vertical" flexItem />
          {backOfficeEmployee && (
            <Box>
              <Typography variant="subtitle2">{'shop.order-history.contact-back-office-employee'}</Typography>
              <Typography variant="subtitle1">{backOfficeEmployeeFullName}</Typography>
              <Typography variant="subtitle1">{backOfficeEmployee.phone}</Typography>
              <Link href={`mailto:${BACK_OFFICE_EMAIL}`} underline="none">
                {BACK_OFFICE_EMAIL}
              </Link>
            </Box>
          )}
        </Box>
      </Card>
    </Box>
  )
}

export default ContactInfoCard
